import * as server from "app/redux/balances/balancesCrud";
import balancesSlice from "app/redux/balances/balancesSlice";
import {errorHandler, notifyAction, successNotification} from "app/common/util/Helpers";

// Balances Redux Actions
const {
    actions: {
        isLoading,
        setNotification,
        balanceFetched,
        banksFetched,
        payoutsFetched,
        walletHistoryFetched
    }
} = balancesSlice;

/*****
 *  Balances Handlers
 */
export const fetchBalance = businessId => dispatch => {
    server.fetchBalanceReq(businessId)
        .then(({data: {data}}) => dispatch(balanceFetched(data)))
        .catch(errorHandler(dispatch, setNotification));
};

export const fetchBanks = _ => dispatch => {
    server.fetchBanksReq()
        .then(({data: {data}}) => dispatch(banksFetched(data)))
        .catch(errorHandler(dispatch, setNotification));
};

export const resolveNuban = data => dispatch => {
    dispatch(isLoading());
    server.resolveNubanReq(data)
        .then(({data: {data}}) => dispatch(setNotification(notifyAction("nubanResolved", data))))
        .catch(errorHandler(dispatch, setNotification));
};

export const generateOTP = businessId => dispatch => {
    server.generateOTPReq(businessId)
        .then(_ => dispatch(setNotification(successNotification("OTP sent to your email box", "OTPGenerated"))))
        .catch(errorHandler(dispatch, setNotification));
};

export const fetchPayouts = businessId => dispatch => {
    server.fetchPayoutsReq(businessId)
        .then(({data: {data}}) => dispatch(payoutsFetched(data)))
        .catch(errorHandler(dispatch, setNotification));
};

export const addPayoutAccount = data => dispatch => {
    dispatch(isLoading());
    server.addPayoutAccountReq(data)
        .then(_ => dispatch(setNotification(successNotification("Payout Account Added Successfully", "payoutAdded"))))
        .catch(errorHandler(dispatch, setNotification));
};

export const withdraw = (walletId, data) => dispatch => {
    dispatch(isLoading());
    server.withdrawReq(walletId, data)
        .then(_ => dispatch(setNotification(successNotification("Withdrawal Initiated Successfully", "withdrawalInitiated"))))
        .catch(errorHandler(dispatch, setNotification));
};

export const setDefaultPayoutAccount = data => dispatch => {
    dispatch(isLoading());
    server.setDefaultPayoutAccountReq(data)
        .then(_ => dispatch(setNotification(successNotification("Default Payout Account Set Successfully", "defaultPayout"))))
        .catch(errorHandler(dispatch, setNotification));
};

export const exportBalances = (businessId, email, start, end) => dispatch => {
    dispatch(isLoading());
    server.exportBalancesReq(businessId, email, start, end)
        .then(_ => dispatch(setNotification(successNotification("Report is being generated, you'll be sent an email when it's done", "balanceExportRequested"))))
        .catch(errorHandler(dispatch, setNotification));
};

export const deletePayoutAccount = data => dispatch => {
    dispatch(isLoading());
    server.deletePayoutAccountReq(data)
        .then(_ => dispatch(setNotification(successNotification("Payout Account Deleted Successfully", "payoutDeleted"))))
        .catch(errorHandler(dispatch, setNotification));
};

export const fetchWalletHistory = (businessId, walletId, type = "sales") => dispatch => {
    server.fetchWalletHistoryReq(businessId, walletId, type)
        .then(({data: {data}}) => dispatch(walletHistoryFetched({data, businessId, walletId, type})))
        .catch(errorHandler(dispatch, setNotification));
};

